export const messages = {
    emailRequired: "Please enter Email Address.",
    phoneRequired: "Please enter mobile number",
    emailInvalid: "Please enter a valid Email Address.",
    passwordRequired: "Please enter Password.",
    passwordLen: "Password should be at least 6 characters long.",
    passwordInvalid: "Password must be 6 to 14 characters and contain at least one capital letter.",
    usernameRequired: "Please enter Username.",
    usernameInvalid: "Please enter a valid Username. Only characters, numerals and .-_ are allowed in Username",
    usernameLen: "Username should be at least 3 characters long.",
    failed: "Request failed, please try again.",
    loginSuccess: "Logged in successfully.",
    signupSuccess: "Signed Up successfully.",
    roomClaimSuccess: "Room claimed successfully.",
    emailSendSuccess: "Email sent successfully.",
    textSendSuccess: "Text sent successfully.",
    emailOrTextSendError: "Sorry can't send at this time.",
    verifyContact: "Please verify the mobile number.",
    invalidEmail: "You have entered an invalid email address!",
    invalidRoom: "Please enter a valid room name.",
    roomRequired: "Room name is required.",
    unavailableRoom: "Sorry, No Room Available.",
    roomUpdateSuccess: "Room updated successfully.",
    logoutSuccess: "Logout successfully.",
    alreadyClaimed: "You have already claimed this room.",
    selectcategory: "Please select room category",
    settingsError: "We can't update this settings right now.",
    contactAdmin: "We can't login you this time, Please contact admin.",
    invalidIp: "Please enter the correct IP address.",
    enteredClaimedRoom: "This room name belongs to another user. Please choose a different room name.",
    invalidNumericRoom: "The room name should not start with a number.",
    invalidRoomLength: "The room name should not be greater than 25 words in length.",
    roomnameRequired: "Please enter a room name to join.",
    enterDiffRoom: "You are already in this room. Please enter a different room name to continue.",
    enterDiffIpAddress: "The IP address you have entered is invalid. Please choose a different room name or IP address.",
    notCurrentHost: "Only the current host can make this change.",
    notCurrentHostIp: "Only the recommended host can make this change.",
    notCurrentModIp: "Only the moderator/recommended host can make this change.",
    requiredName: "Name is required.",
    requiredEmail: "Email is required.",
    requiredPhone: "Phone Number is required.",
    requiredTime: "Available Time is required.",
    requiredComment: "Comment is required.",
    notvalidEmail: "Email is invalid.",
    notvalidPhone: "Phone Number is invalid.",
    contactTutorialAdmin: "Please contact admin.",
    preparingToRecord: "Your recording is preparing, please wait.",
    confirmUnpairDevice: "Are you sure you want to disconnect? The rest of the participant(s) will move to the best low latency server.",
    confirmDisconnectRoom: "You are the host for the current room, disconnecting would disconnect all other users in this room. Do you still wish to continue?",
    confirmDisconnectRoomOwner: "You are the room owner for the current room, disconnecting would disconnect all other users in this room. Do you still wish to continue?",
    confirmShareonFB: "Do you wish to download the file or post it on Facebook? Choose any one option and continue.",
    confirmSingleModDisconnect: "You are the owner for the current room, disconnecting would disconnect all other users in this room. Do you still wish to continue?",
    confirmMultiModDisconnect: "You are the owner of this room. You can end the meeting for all participants or you can leave the meeting.",
    musicModeOn: "Music Mode has been enabled for this meeting. While in this mode, please mute your mic when not speaking or playing. It is also advised that you wear headphones if possible.<br/>Please note: Music mode is not available for mobile devices.",
    musicModeOff: "The moderator has disabled Music Mode for this room. Your room will now be refreshed to disable this effect.",
    musicModeOnModerator: "You are about to turn on Music Mode. This will reboot the session and turn off a number of audio processing features used specifically for web conferencing. While in this mode, make sure that participants mute their mic when not speaking or playing. It is also advised that you all wear headphones if possible.<br/>Please note: Music mode is not available for mobile devices.",
    musicModeOffModerator: "You are about to turn off Music Mode. This will reboot the session and turn on a number of audio processing features used specifically for web conferencing.",
    musicModeDetected: "The moderator has enabled Music Mode for this room. Your room will now be refreshed to enable this effect. Please listen to the audio using headphones to prevent feedback and echo.",
    musicModeMessageTime: 10000,
    // musicModeSessionCheck: 10000,
    musicModeSessionCheck: 4500,
    musicModeReload: 12000,
    musicModeTimeLimit: 120,
    fileTypeError: "This file type is not allowed. Accepted file types are ",
    fileSizeMinError: "File size should be more than 0MB",
    fileSizeMaxError: "File size cannot exceed more than 5MB",
    pdfSizeMaxError: "PDF files cannot be larger than 100MB",
    mp3SizeMaxError: "MP3 files cannot be larger than 200MB",
    fileUploadError: "File Upload Error",
    fileUploadSuccess: "File uploaded successfully",
    fileDeleteSuccess: "File deleted successfully",
    mediaFileRequired: "Please select media file",
    mediaCategoryRequired: "Please select media category",
    correctMediaCategory: "Please select correct media category",
    teacherWillWait: 5000,
    teacherDisconnect: "Teacher ended the conference",
    grantSecModeratorTitle: "Grant Secondary moderator",
    grantSecModeratorTitleRemove: "Remove Secondary moderator",
    grantSecModeratorText: "Are you sure you want to grant secondary moderator rights to user?",
    grantSecModeratorTextRemove: "Remove secondary grant moderator?",
    studentWaitingMessage: "Waiting for your teacher to join...",
    studentWaitingMusicModeMessage: "Please wait while we prepare your room.",
    invalidRoomName: "The room name should not start with a number",
    copyPassword: "Room password copied.",
    tooltipCopyPassword: "Copy room password",
    inviteNameValidation: "Please enter your name.",
    inviteNameLength: "Name should be at least 3 characters long.",
    inviteNameInvalid: "Please enter a valid name. Only characters, numerals and .-_ are allowed in name",
    inviteEmailRequired: "Please enter your Email Address.",
    inviteEmailInvalid: "Please enter the valid Email Address. "
}


export const stripeMessage = {
    roomAmount: "Please enter the entrance fees.",
    roomAmountLess: "Room amount should be greater than 10.",
    roomAmountGreat: "Room amount should be less than 1000.",
    roomAmountMin: 10,
    roomAmountMax: 1000,
    successFlushTime: 20000,
    yourPaymentProgress: "Your payment is in progress, please don't reload or kill the page.",
    endDate: "Please select end date.",
    paymentAccountCreate: "You must create a stripe account before enabling a paid room.",
    paymentAccountFailed: "Your payment account needs additional information to be activated.",
    paymentAccountVerification: "Please wait while your account is under verification. This generally will take few minutes. Please check your email for an update. You may be provided a link to enter the additional required information.",
    paymentAccountApproved: "Your payment account verification is complete and available to use. Please set the room fee and end date for this room.",
    createConnectAccount: "Verify bank account information",
    updateConnectAccount: "Update bank account information",
    updateAdditionalConnectAccount: "Provided additional bank account information",
    roomName: "Please enter room name.",
    category: "Please select room category.",
    endDate: "Please select end date.",
    startDate: "Please select start date.",
    subscriptionPurchased: "Subscription purchased successfully",
    recordingDeleted: "Recording deleted.",
    paymentAccountNVerify: "Your payment account is not verified, please update",
    paymentAccountRequire: "Your don't have connect account, please create before make this room paid.",
    endDateLess: "End date should be greater or equal to start date.",
    enabledAccount: "Your account is now Enabled.",
    approvedAccount: "You account is now approved."
}



export const messagesLabel = {
    guestLoginText: "In order to use this feature, you must create an account. Please click the \"Sign Up\" button to create an account."
}